import React, { useState } from "react";
import defaultMusicbull from "../../../../Assets/defaultMusicbull.png"
import "./Auctionmodal.scss";
import { Accordion, Modal, Table } from "react-bootstrap";
import {
  InstaIcon,
  LiveIcon,
  SpotifyIcon,
  UtubeIcon,
} from "../../../../Assets/svgIcons";
import { Link } from "react-router-dom";
import { updateInfluencerInvitation } from "../../../../Services/prod/auth.service";
import { toast } from "react-toastify";
import Countdown from "../../../../components/countdown/countdown.component";
import moment from "moment";
import { formatCommaNumbers } from "../../../../Utils/common.utils";

const Auctionmodal = ({
  show,
  handleClose,
  auctionData,
  state,
  setInvitationStatus,
  tierInfo
}) => {
  const [disable, setDisable] = useState(false);
  const [showContent, setShowContent] = useState(true);

  const handleRequest = async (STATUS) => {
    try {
      setDisable(true);
      const updateRequestPayload = {
        status: STATUS,
        id: state?.invitationData?.invitation_id,
      };
      const updateRequestRes = await updateInfluencerInvitation(
        updateRequestPayload
      );
      if (
        updateRequestRes?.status === 200 ||
        updateRequestRes?.status === 201
      ) {
        setInvitationStatus(STATUS);
        setDisable(false);
        toast.success(updateRequestRes?.message);
        handleClose();
      } else {
        setInvitationStatus("PENDING");
        setDisable(false);
        toast.error(updateRequestRes?.message);
        console.log("API ERROR");
      }
    } catch (error) {
      setDisable(false);
      console.log(error, "error");
    }
  };

  const showTimeFun = (status, auctionDate) => {
    switch (status) {
      case "Progress":
        return <Countdown date={auctionDate} />;
      case "Ended":
        return `Auction Ended`;
      case "Scheduled":
        return ` ${moment(auctionDate).format("MMMM Do YYYY")}`;
      default:
        return true;
    }
  };

  return (
    <Modal
      show={show}
      centered
      onHide={handleClose}
      className="auction_modal_design"
    >
      <h2>
        {auctionData?.issuerName} /{" "}
        <span>Auction ID {auctionData?.auctionID}</span>
      </h2>
      <div className="auction_very_header">
        <p className="live">
          <LiveIcon /> Live
        </p>
        <h3>
          {auctionData?.AuctionStatus === "Scheduled"
            ? "Scheduled "
            : auctionData?.AuctionStatus === "Progress"
            ? "Auction Ends in "
            : ""}
          <span>
            {showTimeFun(
              auctionData?.AuctionStatus,
              auctionData?.AuctionStatus === "Progress"
                ? auctionData?.endDate
                : auctionData?.AuctionStatus === "Scheduled"
                ? auctionData?.startDate
                : ""
            )}
          </span>
        </h3>
      </div>
      <div className="auction_details">
        <div className="auction_details_img">
          <img
            src={auctionData?.imgSrc?.[0] ? auctionData?.imgSrc[0] : defaultMusicbull}
            alt="sample-auction"
          />
          {/* <Link to="#">Auction Page</Link> */}
        </div>
        <div className="auction_details_financial">
          <h3>Financials</h3>
          <ul>
            <li>
              <h4>Last 12 Months Earnings</h4>
              <p>{auctionData?.Last12MonthsEarningsStr}</p>
            </li>
            <li>
              <h4>3-Year Average Earnings</h4>
              <p>{auctionData?.["3YearAverageEarningStr"]}</p>
            </li>
            <li>
              <h4>Last 12 Months Yield</h4>
              <p>{auctionData?.Last12MonthsYieldStr}</p>
            </li>
            <li>
              <h4>3-Year Average Yield</h4>
              <p>{auctionData?.["3YearAverageYieldStr"]}</p>
            </li>
            <li>
              <h4>Dollar Age </h4>
              <p>{auctionData?.DollarAgeStr}</p>
            </li>
            <li>
              <h4>Earning's Multiple (P/E)</h4>
              <p>{auctionData?.EarningMultiplePEStr}</p>
            </li>
            <li>
              <h4>Market Cap</h4>
              <p>{auctionData?.MarketCapStr}</p>
            </li>
          </ul>
          <div className="social_media">
            <Link to="#">
              <UtubeIcon />
              <div>
                {auctionData?.youtubeMonthlyListeners || "0"}
                <span>Monthly Views</span>
              </div>
            </Link>
            <Link to="#">
              <SpotifyIcon />
              <div>
                {auctionData?.spotifyMonthlyListeners || "0"}
                <span>Monthly Streams</span>
              </div>
            </Link>
            <Link to="#">
              <InstaIcon />
              <div>
                {auctionData?.instagramMonthlyListeners || "0"}
                <span>Followers</span>
              </div>
            </Link>
          </div>
        </div>
        <div className="auction_details_rights">
          <h3>Included Rights</h3>
          <ul>
            <li>
              <h4>Musical Composition</h4>
              <p>{auctionData?.rights[0].description}</p>
            </li>
            <li>
              <h4>Sound Recording</h4>
              <p>{auctionData?.rights[1].description}</p>
            </li>
            <li>
              <h4>Collection Agents</h4>
              <p>{auctionData?.rights[2]?.description}</p>
            </li>
            <li>
              <h4>Copyrights</h4>
              <p>{auctionData?.rights[3]?.description}</p>
            </li>
            <li>
              <h4>Listing Term</h4>
              <p>{auctionData?.rights[5]?.description}</p>
            </li>
            <li>
              <h4>Royalty Distribution Dates</h4>
              <p>{auctionData?.rights[6]?.description}</p>
            </li>
            <li>
              <h4>Rights Exp Date</h4>
              <p>Included Date</p>
            </li>
            <li>
              <h4>Ownership per Unit</h4>
              <p>0.01%</p>
            </li>
            <li>
              <h4>Issuer Name</h4>
              <p>{auctionData?.issuerName}</p>
            </li>
            <li>
              <h4>Number of Tracks</h4>
              <p>{auctionData?.rights[7]?.description}</p>
            </li>
          </ul>
        </div>
      </div>
      <div className="about_auction">
        <button
          type="button"
          onClick={() => setShowContent(!showContent)}
          className="about_auction_btn"
        >
          About the Auction
        </button>
        {showContent && (
          <p>
            {auctionData?.description}
            {/* <Link to="#">Read More... </Link> */}
          </p>
        )}
      </div>
      <div className="auction_commission">
        <h3>Auction Commissions</h3>
        <Table responsive>
          <thead>
            <tr>
              <th>Tier</th>
              <th>Monthly Listeners</th>
              <th>Commission</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tier {auctionData?.listingTier??3}</td>
              <td>
                {auctionData?.listingTier === "1" &&
                  `${formatCommaNumbers(
                    tierInfo?.tier1_min
                  )} and ${formatCommaNumbers(tierInfo?.tier1_max)}`}
                {auctionData?.listingTier === "2" &&
                  `${formatCommaNumbers(
                    tierInfo?.tier2_min
                  )} to ${formatCommaNumbers(tierInfo?.tier2_max)}`}
                {auctionData?.listingTier === "3" &&
                  `${formatCommaNumbers(
                    tierInfo?.tier3_min
                  )} to ${formatCommaNumbers(tierInfo?.tier3_max)}`}
                  {!auctionData?.listingTier  &&
                  `${formatCommaNumbers(
                    tierInfo?.tier3_min
                  )} to ${formatCommaNumbers(tierInfo?.tier3_max)}`}
              </td>
              <td>{state?.auctionCommision}%</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div className="action_box">
        <button
          className="accept_btn"
          onClick={() => handleRequest("ACCEPTED")}
          disabled={disable}
        >
          Accept
        </button>
        <button
          className="reject_btn"
          onClick={() => handleRequest("REJECTED")}
          disabled={disable}
        >
          Decline
        </button>
      </div>
    </Modal>
  );
};

export default Auctionmodal;
